module.exports = __webpack_public_path__ + "static/media/error-svgrepo-com.712b927c.svg";